import React from 'react';
import PropTypes from 'prop-types';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import { labelName } from '../../UtilsWeb';

const TextInput = ({ input, label, meta: { touched, error }, style, ...custom }) => (
  <FormControl
    variant="standard"
    error={touched && !!error}
    aria-describedby={label}
    fullWidth
    style={{ marginBottom: 16, ...style }}
  >
    <InputLabel htmlFor="textInput">{label}</InputLabel>
    <Input
      id="textInput"
      {...input}
      inputProps={{ 'aria-label': input.name }}
      {...custom}
      autoComplete={custom?.autoComplete && custom.autoComplete}
    />
    {touched && error && <FormHelperText> {labelName(error)}</FormHelperText>}
  </FormControl>
);

TextInput.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  style: PropTypes.object,
};

TextInput.defaultProps = {
  style: {},
};

export default TextInput;
